import { useEffect } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { CleverTapBaseData, Initialization } from "../../utils/CleverTap";
import { isEmpty } from "lodash";
import { DEVICE_TYPE } from "../../utils/constants";
import { useLazySaveCustomerNavigationQuery } from "../Feature_GeneralAppElements/GeneralAppElements_Api";
import { getOnboardingChannelId } from "../../utils/conversionUtils";

const useCleverTapComp = () => {
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const [saveCustomerNavigationApi] = useLazySaveCustomerNavigationQuery();

  useEffect(() => {
    Initialization();
  }, []);

  useEffect(() => {
    if (!isEmpty(CleverTapBaseData.lastEventFired)) {
      saveCustomerNavigationApi({
        eventName: CleverTapBaseData.lastEventFired,
      });
    }

    const handleCustomEvent = (event: any) => {
      saveCustomerNavigationApi({
        eventName: CleverTapBaseData.lastEventFired || event.detail.eventData,
      });
    };

    window.addEventListener("triggerSaveCustomerNavigation", handleCustomEvent);

    return () => {
      window.removeEventListener(
        "triggerSaveCustomerNavigation",
        handleCustomEvent,
      );
    };
  }, []);

  useEffect(() => {
    const onboardingChannelId = getOnboardingChannelId(csAppSlice.channel);
    const primaryUserCII =
      userDetails?.IS_USER_REGISTERED &&
      userDetails?.customerAndLobDetails?.find(
        (f) => f.PRIMARY_SECONDARY_USER === "primary",
      )?.CII;
    const clientID = csAppSlice.csUserId || userDetails?.CS_USER_ID || "";
    CleverTapBaseData.setBaseData({
      ChannelID: isEmpty(onboardingChannelId) ? "26" : "",
      UserAge: "",
      UserGender: "",
      ClientID: clientID,
      GoldenID: primaryUserCII || "",
      GuestID: "",
      $CleverTap_user_id: "",
      AppsflyerID: "",
      PlatformKey: isEmpty(csAppSlice?.NativeDeviceInfo?.deviceName)
        ? DEVICE_TYPE.WEB
        : DEVICE_TYPE.MOBILE,
    });
  }, [
    csAppSlice?.userDetails?.IS_USER_REGISTERED,
    csAppSlice?.userDetails?.customerAndLobDetails,
    csAppSlice?.csUserId,
    csAppSlice?.NativeDeviceInfo?.deviceName,
  ]);
};
export default useCleverTapComp;
